import * as React from 'react'
import { cn } from '@/src/infrastructure/lib/utils'

interface Props {
  title: string
  description?: string
  action?: React.ReactNode
  children: React.ReactNode
  className?: string
}

export function ChartCard({ title, description, action, children, className }: Props) {
  return (
    <section
      className={cn(
        'bg-surface rounded-2xl border border-outline-variant/30 p-5 md:p-6 flex flex-col gap-4',
        className,
      )}
    >
      <header className="flex items-start justify-between gap-3">
        <div>
          <h2 className="text-base font-bold text-on-surface">{title}</h2>
          {description && (
            <p className="text-xs text-on-surface-variant mt-0.5">{description}</p>
          )}
        </div>
        {action}
      </header>
      <div className="text-primary">{children}</div>
    </section>
  )
}
